import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { KeenSliderInstance } from 'keen-slider';
import * as KeenSlider from 'keen-slider';
import { Subject, interval, takeUntil, timer } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements AfterViewInit, OnChanges {
  
  @ViewChild('whiteDrop') whiteDropEle: ElementRef<HTMLElement>;
  @ViewChild('logoName') logoNameEle: ElementRef<HTMLElement>;
  startLogoSpin: boolean = false
  @Input() showLogo: boolean = false
  @Output() logoReveled: EventEmitter<boolean> = new EventEmitter(false) 
  runningText: string[] = [
    `<p>Fetching current market <br>prices...</p>`,
    `<p>Onboarding new advisors <br>and analyst’s..</p>`,
    `<p>Creating investpacks, fresh from <br>pickright oven </p>`
  ]
  textSlider: KeenSliderInstance;
  @ViewChild("textSliderRef") textSliderRef: ElementRef<HTMLElement>
  textTimer: Subject<any> = new Subject()
  constructor() { }

  ngAfterViewInit(): void {
    this.listenToWhiteDrop()
  }
  
  ngOnChanges(changes: SimpleChanges): void {
      if (changes.showLogo && !changes.showLogo.previousValue && changes.showLogo.currentValue) {
        timer(10).subscribe((res)=> {
          this.listenToNameReveal()
        })
      }
  }

  listenToWhiteDrop(){
    this.whiteDropEle.nativeElement.addEventListener('animationend', (event)=> { 
      this.startLogoSpin = true
      timer(500).subscribe((res)=> {
        if(!this.textSlider){
          this.initSlider()
        }
      });
    }) 
  }

  listenToNameReveal(){
    this.logoNameEle.nativeElement.addEventListener('animationend', (event)=> { this.logoReveled.emit(true)}) 
  }

  initSlider(){
    if(typeof document !== 'undefined'){
      this.textSlider = new KeenSlider.default(this.textSliderRef.nativeElement, {
        loop: true,
        renderMode: "performance",
        initial: 0,
        slides: {
          perView: 1,
          origin: 'center',
        },
        mode: 'snap',
        vertical: true,
      })
      this.autoPlay()
    }
  }

  autoPlay() {
    interval(3000).pipe(takeUntil(this.textTimer)).subscribe(()=> {
      this.textSlider.next()
    })
  }

}
